@let selectedTab = selectedTab$ | async;

<red-header-content>
  <ion-toolbar>
    @if (defaultBackHref) {
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultBackHref"></ion-back-button>
    </ion-buttons>
    }
    <ion-title>Walking Farm&#174;</ion-title>
    @if (selectedTab === walkingFarmMainTabs.New) { @let filtersAppliedNumber = filtersAppliedNumber$ | async;

    <ion-buttons slot="primary">
      <ion-button class="tw:relative tw:overflow-visible" [routerLink]="['filter']">
        <ion-icon slot="icon-only" src="/assets/svg/filter.svg"></ion-icon>
        @if (filtersAppliedNumber) {
        <ion-badge class="tw:absolute tw:-top-0.5 tw:-right-1" color="warning"> {{ filtersAppliedNumber }} </ion-badge>
        }
      </ion-button>
      <ion-button [routerLink]="['help']">
        <ion-icon slot="icon-only" src="/assets/svg/help.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
  @if ((drawMode$ | async) === false) {
  <ion-toolbar [@toolbarSwitchDrawMode]>
    <ion-segment (ionChange)="segmentChange($event)" [value]="selectedTab ?? walkingFarmMainTabs.New">
      <ion-segment-button [value]="walkingFarmMainTabs.New">
        <ion-label>New Farm</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="walkingFarmMainTabs.Saved">
        <ion-label>Saved Farms</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
  } @if (selectedTab === walkingFarmMainTabs.Saved) {
  <ion-toolbar>
    <div class="tw:flex tw:w-full">
      <ion-searchbar
        [debounce]="100"
        (ionInput)="filterSavedFarms($event)"
        [value]="(savedFarmsTextFiler$ | async)"
      ></ion-searchbar>
      <ion-buttons class="tw:h-9">
        <ion-button (click)="refreshSavedFarms()">
          <ion-icon name="refresh"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </ion-toolbar>
  }
</red-header-content>

@switch (selectedTab) { @case (walkingFarmMainTabs.New) {
<ion-content color="light" [scrollX]="false" [scrollY]="false">
  <red-walking-farm-new></red-walking-farm-new>
</ion-content>
} @case (walkingFarmMainTabs.Saved) {
<red-page-content>
  <red-walking-farm-saved></red-walking-farm-saved>
</red-page-content>
} }
